import { useEffect } from "react";

export default function CookieConsent() {
    useEffect(() => {
        // Check if already initialized
        if (document.getElementById('cc_div') || window.initCookieConsent) {
            console.log('Cookie consent already initialized');
            return;
        }

        console.log('Starting cookie consent initialization...');

        // Load CSS first
        const cssLink = document.createElement('link');
        cssLink.rel = 'stylesheet';
        cssLink.href = 'https://cdnwest.radnet.com/cookie-consent/v2/cookieconsent.min.css';
        cssLink.media = 'print';
        cssLink.onload = function() {
            console.log('CSS loaded successfully');
            this.media = 'all';
        };
        cssLink.onerror = function() {
            console.error('Failed to load CSS file');
        };
        document.head.appendChild(cssLink);

        // Load JS and initialize immediately
        const script = document.createElement('script');
        script.src = 'https://cdnwest.radnet.com/cookie-consent/v2/cookieconsent.min.js';
        script.onload = function() {
            console.log('JS loaded successfully');
            // Initialize immediately when script loads
            if (window.initCookieConsent) {
                console.log('Initializing cookie consent...');
                try {
                    window.initCookieConsent().run({
                        autorun: true,
                        current_lang: "en",
                        autoclear_cookies: true,
                        mode: "opt-in",
                        page_scripts: true,
                        analytics: {
                            gtmId: "GTM-M333SKR3",
                            analyticsCategory: "analytics"
                        },
                        gui_options: {
                            consent_modal: {
                                layout: "cloud",
                                position: "bottom center",
                                transition: "slide",
                                swap_buttons: false
                            },
                            settings_modal: {
                                layout: "box",
                                transition: "zoom"
                            }
                        },
                        languages: {
                            en: {
                                consent_modal: {
                                    title: "",
                                    description: 'To understand how you use our Website and to improve your experience, we collect certain important information (e.g., cookies). To learn about what we collect and why read our <a aria-label="Cookie policy" class="cc-link" href="https://www.radnet.com/privacy-statement" target="_blank">Privacy policy</a>. <button type="button" data-cc="c-settings" class="cc-link" aria-haspopup="dialog">Manage your cookie preferences.</button>',
                                    primary_btn: {
                                        text: "Accept",
                                        role: "accept_all"
                                    }
                                },
                                settings_modal: {
                                    title: '<img class="cc-title-logo" src="https://cdnwest.radnet.com/brand/logo-radnet.svg"> <h3>| Cookie preferences</h3>',
                                    save_settings_btn: "Save settings",
                                    accept_all_btn: "Accept all",
                                    reject_all_btn: "Reject all",
                                    cookie_table_headers: [
                                        {col1: "Name"},
                                        {col2: "Domain"},
                                        {col3: "Expiration"},
                                        {col4: "Description"},
                                        {col5: "Type"}
                                    ],
                                    blocks: [
                                        {
                                            title: "Cookie usage",
                                            description: "We use cookies to give you the best experience. By using our site, you agree to our use of cookies. Alternatively, you have the choice to opt-in or opt-out of each optional category when desired.",
                                            cookie_table: []
                                        },
                                        {
                                            title: "Essential information",
                                            description: "This collected information is necessary to provide you with the critical features available on our Website. Because this information is essential to your experience, you are unable to alter these settings and still use the Website.",
                                            toggle: {
                                                value: "necessary",
                                                enabled: true,
                                                readonly: true
                                            },
                                            cookie_table: [
                                                {
                                                    col1: "^prostate",
                                                    col2: "prostate.radnet.com",
                                                    col3: "1 day",
                                                    col4: "Site specific",
                                                    col5: "Permanent cookies",
                                                    is_regex: true
                                                },
                                                {
                                                    col1: "has_js",
                                                    col2: "prostate.radnet.com",
                                                    col3: "1 day",
                                                    col4: "JavaScript on/off",
                                                    col5: "Permanent cookies",
                                                    is_regex: true
                                                },
                                                {
                                                    col1: "__cf_bm",
                                                    col2: "vimeo.com",
                                                    col3: "1 day",
                                                    col4: "Vimeo human/bot detection",
                                                    col5: "Permanent cookies"
                                                },
                                                {
                                                    col1: "vuid",
                                                    col2: "vimeo.com",
                                                    col3: "1 day",
                                                    col4: "Vimeo player",
                                                    col5: "Permanent cookies"
                                                }
                                            ]
                                        },
                                        {
                                            title: "Non-Essential Information",
                                            description: "This information is used to enhance your experience on our Website. If we are unable to collect this important yet non-essential information, certain functions and items (e.g. chat and location maps) will not be available or work as intended.",
                                            toggle: {
                                                value: "analytics",
                                                enabled: true,
                                                readonly: false,
                                                reload: "on_disable"
                                            },
                                            cookie_table: [
                                                {
                                                    col1: "^_ga",
                                                    col2: "google.com",
                                                    col3: "2 years",
                                                    col4: "Google Analytics session",
                                                    col5: "Permanent cookie",
                                                    is_regex: true
                                                },
                                                {
                                                    col1: "_gid",
                                                    col2: "google.com",
                                                    col3: "1 day",
                                                    col4: "Google Analytics ID",
                                                    col5: "Permanent cookie"
                                                },
                                                {
                                                    col1: "_gat",
                                                    col2: "google.com",
                                                    col3: "1 minute",
                                                    col4: "Google Analytics request rate control",
                                                    col5: "Temporary cookie"
                                                }
                                            ]
                                        },
                                        {
                                            title: "California Residents",
                                            description: 'If you reside in California and would like to make a request related to your personal information, please fill out our Consumer Rights Request Form.<br><a class="c-bn c-bn-bl" href="https://www.radnet.com/consumer-rights-ca" target="_blank">Your Privacy Choices</a>',
                                            cookie_table: []
                                        }
                                    ]
                                }
                            }
                        }
                    });
                    console.log('Cookie consent initialized successfully');
                } catch (error) {
                    console.error('Error initializing cookie consent:', error);
                }
            } else {
                console.error('Cookie consent script loaded but initCookieConsent not found');
            }
        };
        
        script.onerror = function() {
            console.error('Failed to load cookie consent script');
        };
        
        document.head.appendChild(script);

        // Cleanup function
        return () => {
            // Remove the script and CSS link if component unmounts
            const existingScript = document.querySelector('script[src="https://cdnwest.radnet.com/cookie-consent/v2/cookieconsent.min.js"]');
            const existingCSS = document.querySelector('link[href="https://cdnwest.radnet.com/cookie-consent/v2/cookieconsent.min.css"]');
            
            if (existingScript) {
                existingScript.remove();
            }
            if (existingCSS) {
                existingCSS.remove();
            }
        };
    }, []);

    return null;
} 